// Single source of truth for all sport definitions.
// To add a new sport: add an entry here, then (if new category) create a form component in src/components/workouts/.

export const SPORTS = {
    // ── GRAPPLING ─────────────────────────────────────────────────────────
    gi_bjj: {
        name: '도복 주짓수', color: '#9b8cff', sub: '그래플링', category: 'grappling',
        formTitle: '그래플링 세션',
        formDesc: '포지션, 기술(성공/시도/당함), 스파링 라운드를 중심으로 남겨요.',
        focusPlaceholder: '오늘의 주제 (예: 하프가드 패스, 백 컨트롤)',
        isBjj: true,
    },
    nogi_bjj: {
        name: '노기 주짓수', color: '#9b8cff', sub: '그래플링', category: 'grappling',
        formTitle: '그래플링 세션',
        formDesc: '포지션, 기술(성공/시도/당함), 스파링 라운드를 중심으로 남겨요.',
        focusPlaceholder: '오늘의 주제 (예: 레그락, 넥타이 공방)',
        isBjj: true,
    },
    wrestling_grappling: {
        name: '레슬링', color: '#9b8cff', sub: '그래플링', category: 'grappling',
        formTitle: '그래플링 세션',
        formDesc: '테이크다운, 기술, 스파링 라운드를 중심으로 남겨요.',
        focusPlaceholder: '오늘의 주제 (예: 더블렉, 상대 그립 끊기)',
    },
    judo: {
        name: '유도', color: '#9b8cff', sub: '그래플링', category: 'grappling',
        formTitle: '그래플링 세션',
        formDesc: '기술(한판/절반), 메치기, 굳히기를 중심으로 남겨요.',
        focusPlaceholder: '오늘의 주제 (예: 업어치기, 허리후리기)',
    },

    // ── STRIKING ──────────────────────────────────────────────────────────
    kickboxing: {
        name: '킥복싱', color: '#ff7c5c', sub: '타격', category: 'striking',
        formTitle: '타격 세션',
        formDesc: '훈련 구성, 기술 카테고리, 스파링 라운드를 추적해요.',
        focusPlaceholder: '오늘의 주제 (예: 잽 거리, 로우킥 카운터)',
    },
    boxing: {
        name: '복싱', color: '#ff7c5c', sub: '타격', category: 'striking',
        formTitle: '타격 세션',
        formDesc: '훈련 구성, 기술 카테고리, 스파링 라운드를 추적해요.',
        focusPlaceholder: '오늘의 주제 (예: 잽-크로스 연계, 바디 훅)',
    },
    muaythai: {
        name: '무에타이', color: '#ff7c5c', sub: '타격', category: 'striking',
        formTitle: '타격 세션',
        formDesc: '훈련 구성, 기술 카테고리, 스파링 라운드를 추적해요.',
        focusPlaceholder: '오늘의 주제 (예: 테프 방어, 무릎 클린치)',
    },

    // ── COMBAT ────────────────────────────────────────────────────────────
    mma: {
        name: 'MMA', color: '#4ecdc4', sub: '종합격투기', category: 'combat',
        formTitle: 'MMA 세션',
        formDesc: '타격과 그래플링이 섞인 종합격투기 훈련을 남겨요.',
        focusPlaceholder: '오늘의 주제 (예: 케이지 레슬링, 타격 후 테이크다운)',
    },

    // ── STRENGTH ──────────────────────────────────────────────────────────
    weight: {
        name: '웨이트 트레이닝', color: '#5ba4f5', sub: '무산소', category: 'strength',
        formTitle: '웨이트 세션',
        formDesc: '운동별 세트, 반복, 중량과 자극 부위를 기록해요.',
        focusPlaceholder: '오늘의 목표 (예: 등 볼륨, 5RM 테스트)',
    },

    // ── CARDIO ────────────────────────────────────────────────────────────
    // cardioFields 배열로 폼에서 렌더할 필드를 결정합니다.
    zone2: {
        name: '유산소', color: '#ffb347', sub: '유산소', category: 'cardio',
        formTitle: '유산소 세션',
        formDesc: '운동 강도와 심박수를 중심으로 추적해요.',
        focusPlaceholder: '오늘의 목표 (예: Zone2 유지, 회복 운동)',
        cardioFields: ['distance', 'calories', 'avgHR'],
    },
    hiit: {
        name: '고강도 인터벌', color: '#ffb347', sub: '유산소', category: 'cardio',
        formTitle: '인터벌 세션',
        formDesc: '인터벌 구성과 강도를 중심으로 추적해요.',
        focusPlaceholder: '오늘의 목표 (예: 타바타, 30/30 인터벌)',
        cardioFields: ['interval', 'calories', 'avgHR'],
    },
    outdoor_run: {
        name: '실외 러닝', color: '#ffb347', sub: '유산소', category: 'cardio',
        formTitle: '러닝 세션',
        formDesc: '거리, 페이스, 심박수를 중심으로 추적해요.',
        focusPlaceholder: '오늘의 목표 (예: LSD 15km, 5분/km 유지)',
        cardioFields: ['distance', 'pace', 'calories', 'avgHR'],
    },
    indoor_cycle: {
        name: '실내 사이클', color: '#ffb347', sub: '유산소', category: 'cardio',
        formTitle: '실내 사이클 세션',
        formDesc: '거리, 파워, 케이던스, 심박수를 추적해요.',
        focusPlaceholder: '오늘의 목표 (예: FTP 테스트, Zone2 60분)',
        cardioFields: ['distance', 'power', 'rpm', 'calories', 'avgHR'],
    },
    road_cycle: {
        name: '로드 사이클', color: '#ffb347', sub: '유산소', category: 'cardio',
        formTitle: '로드 사이클 세션',
        formDesc: '거리, 속도, 파워, 고도, 심박수를 추적해요.',
        focusPlaceholder: '오늘의 목표 (예: 장거리 라이딩, 힐 클라임)',
        cardioFields: ['distance', 'speed', 'power', 'elevation', 'calories', 'avgHR'],
    },
    stairmill: {
        name: '스텝밀', color: '#ffb347', sub: '유산소', category: 'cardio',
        formTitle: '스텝밀 세션',
        formDesc: '층수, 분당 스텝, 저항 레벨, 심박수를 중심으로 기록해요.',
        focusPlaceholder: '오늘의 목표 (예: 레벨 12로 20분, 심박 150 유지)',
        cardioFields: ['floors', 'stepRate', 'level', 'calories', 'avgHR'],
    },

    // ── LEGACY (기존 데이터 하위 호환) ───────────────────────────────────
    bjj: { name: '그래플링', color: '#9b8cff', sub: '기존 기록', category: 'grappling', legacy: true },
    striking: { name: '타격', color: '#ff7c5c', sub: '기존 기록', category: 'striking', legacy: true },
    wrestling: { name: 'MMA', color: '#4ecdc4', sub: '기존 기록', category: 'combat', legacy: true },
    cardio: { name: '유산소', color: '#ffb347', sub: '기존 기록', category: 'cardio', legacy: true },
};

// 카디오 필드 정의 - CardioForm이 이 정보로 인풋을 렌더합니다.
export const CARDIO_FIELD_DEFS = {
    distance:  { label: '거리 (km)',           type: 'number', step: '0.1', placeholder: '0.0',  stateKey: 'dist' },
    calories:  { label: '칼로리 (kcal)',        type: 'number',              placeholder: '300',  stateKey: 'cal' },
    avgHR:     { label: '평균 심박수 (bpm)',     type: 'number',              placeholder: '140',  stateKey: 'avgHR' },
    pace:      { label: '페이스 (분:초/km)',     type: 'text',                placeholder: '5:30', stateKey: 'pace' },
    power:     { label: '평균 파워 (W)',         type: 'number',              placeholder: '200',  stateKey: 'power' },
    rpm:       { label: '케이던스 (RPM)',        type: 'number',              placeholder: '85',   stateKey: 'rpm' },
    speed:     { label: '평균 속도 (km/h)',      type: 'number', step: '0.1', placeholder: '25.0', stateKey: 'speed' },
    elevation: { label: '고도 상승 (m)',         type: 'number',              placeholder: '300',  stateKey: 'elevation' },
    floors:    { label: '총 층수',               type: 'number',              placeholder: '80',   stateKey: 'floors' },
    stepRate:  { label: '분당 스텝 수',          type: 'number',              placeholder: '70',   stateKey: 'stepRate' },
    level:     { label: '저항 레벨',             type: 'number',              placeholder: '10',   stateKey: 'level' },
    // 'interval'은 CardioForm에서 특수 렌더링
};

// 헬퍼 함수
export const sportCategory = sport => SPORTS[sport]?.category || sport;
export const isGrapplingSport = sport => sportCategory(sport) === 'grappling';
export const isStrikingSport = sport => sportCategory(sport) === 'striking';
export const isCombatSport = sport => ['grappling', 'striking', 'combat'].includes(sportCategory(sport));
export const isCardioSport = sport => sportCategory(sport) === 'cardio';
export const isStrengthSport = sport => sportCategory(sport) === 'strength';
export const selectableSports = () => Object.entries(SPORTS).filter(([, v]) => !v.legacy);

export const legacySportKey = record => {
    const normalizeGi = v => ({ '도복': '도복 주짓수', '노기': '노기 주짓수' }[v] || v || '도복 주짓수');
    if (record.sport === 'bjj') {
        return ({
            '도복 주짓수': 'gi_bjj', '노기 주짓수': 'nogi_bjj',
            '레슬링': 'wrestling_grappling', '유도': 'judo',
        })[normalizeGi(record.gi)] || 'gi_bjj';
    }
    if (record.sport === 'striking') {
        return ({ '킥복싱': 'kickboxing', '복싱': 'boxing', '무에타이': 'muaythai' })[record.strType] || 'kickboxing';
    }
    if (record.sport === 'wrestling') return 'mma';
    if (record.sport === 'cardio') {
        return ({
            '유산소': 'zone2', '고강도 인터벌': 'hiit', '실외 러닝': 'outdoor_run',
            '실내 사이클': 'indoor_cycle', '로드 사이클': 'road_cycle', '스텝밀': 'stairmill',
        })[record.cardioType] || 'zone2';
    }
    return record.sport;
};
